import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'CellDualValue';

const classes = {
  container: `${PREFIX}-container`,
  primaryValue: `${PREFIX}-primaryValue`,
  secondaryValue: `${PREFIX}-secondaryValue`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  [`& .${classes.primaryValue}`]: {
    color: 'rgba(1, 16, 18, 0.90)',
  },
  [`& .${classes.secondaryValue}`]: {
    color: 'rgba(1, 16, 18, 0.60)',
  },
}));

type CellDualValueProps = {
  primaryValue: string;
  secondaryValue: string;
};

const CellDualValue = ({
  primaryValue,
  secondaryValue,
}: CellDualValueProps) => (
  <StyledBox className={classes.container}>
    <span className={classes.primaryValue}>{primaryValue}</span>
    <span className={classes.secondaryValue}>{secondaryValue}</span>
  </StyledBox>
);

export { CellDualValue };
export type { CellDualValueProps };
